import React from 'react';
import LineInTimeline from './LineInTimeline';
import { useEditLineContext } from '../../../contexts/EditLine';

export default function LineInTimelineOnEdit({
  line,
  lineNum,
  firstLine,
  handleLineSubmit,
  addOrDeleteError,
  firstProduct,
  timelineInfo,
}: any) {
  const { setLine: setEditLine } = useEditLineContext();
  return (
    <LineInTimeline
      line={line}
      firstLine={firstLine}
      handleLineSubmit={handleLineSubmit}
      addOrDeleteError={addOrDeleteError}
      firstProduct={firstProduct}
      timelineInfo={timelineInfo}
      setEditLine={setEditLine}
    />
  );
}
